import angular from 'angular';

/**
 * Provides static access to the AngularJS injector service attached to the document body.
 * Used to retrieve AngularJS services outside of the normal dependency injection context.
 */
export class AngularInjector {
    /** Returns the raw AngularJS injector instance from the document body element. */
    public static getTrueRealAngularInjectorInstance(): angular.auto.IInjectorService {
        return angular.element(document.body).injector();
    }

    /** Retrieves a registered AngularJS service by name. */
    public static get<T>(name: string): T {
        return angular.element(document.body).injector().get<T>(name);
    }

    /** Checks whether a service with the given name is registered in the injector. */
    public static has(name: string): boolean {
        return angular.element(document.body).injector().has(name);
    }
}
